import { AcademicOfferFormDataLoader } from '../loaders/AcademicOfferFormDataLoader';
import { AcademicOfferSummaryContent } from '../parts/Summary/AcademicOfferSummary';
import { AcademicOfferSummaryLoader } from '../parts/Summary/loaders/AcademicOfferSummaryLoader';

export function AcademicOfferSummaryStep() {
  return (
    <AcademicOfferFormDataLoader>
      <AcademicOfferSummaryLoader>
        <AcademicOfferSummaryContent />
      </AcademicOfferSummaryLoader>
    </AcademicOfferFormDataLoader>
  );
}
